let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2gXpn")).then(() => parcelRequire('6hsJR'));